module.exports = __webpack_public_path__ + "static/media/home-middle-bg.ae6809e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/home-middle-bg.png
// module id = 1291
// module chunks = 0